import { FC } from "react"
import ReactPlayer from "react-player"
import "./SimpleVideoPlayer.less"

type Props = {
  videoUrl: string
}

const SimpleVideoPlayer: FC<Props> = ({ videoUrl }) => {
  return (
    <ReactPlayer
      url={videoUrl}
      playing={false}
      muted
      loop={false}
      controls={true}
      className={`simple-video-player`}
      width={"100%"}
      height={"100%"}
      playsinline={true}
    />
  )
}

export default SimpleVideoPlayer
